import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

// 卡牌稀有度接口
export interface CardRarity {
  id: number;
  name: string;
  sort: number;
  cards_count?: number;
  created_at: string;
  updated_at: string;
}

// 下拉选项接口
export interface CardRarityOption {
  id: number;
  name: string;
}

@Module
export default class CardRarityModule extends VuexModule {
  card_rarity_list = [] as Array<CardRarity>;
  card_rarity_count = 0;
  card_rarity = {} as CardRarity;
  all_card_rarities = [] as Array<CardRarityOption>;

  get currentCardRarityList(): Array<CardRarity> {
    return this.card_rarity_list;
  }

  get currentCardRarity(): CardRarity {
    return this.card_rarity;
  }

  get currentCardRarityCount(): number {
    return this.card_rarity_count;
  }

  get currentAllCardRarities(): Array<CardRarityOption> {
    return this.all_card_rarities;
  }

  @Mutation
  [Mutations.SET_CARD_RARITY_LIST](card_rarity_list: Array<CardRarity>) {
    this.card_rarity_list = card_rarity_list;
  }

  @Mutation
  [Mutations.SET_CARD_RARITY](card_rarity: CardRarity) {
    this.card_rarity = card_rarity;
  }

  @Mutation
  [Mutations.SET_CARD_RARITY_COUNT](count: number) {
    this.card_rarity_count = count;
  }

  @Mutation
  [Mutations.SET_ALL_CARD_RARITIES](all_card_rarities: Array<CardRarityOption>) {
    this.all_card_rarities = all_card_rarities;
  }

  @Action
  [Actions.GET_CARD_RARITY_LIST](params: Record<string, unknown>) {
    ApiService.setHeader();

    let queryString = "?";
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryString += "&" + key + "=" + params[key];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/card_rarities", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_RARITY_LIST, data["card_rarities"] || []);
          this.context.commit(Mutations.SET_CARD_RARITY_COUNT, data["total_result"] || 0);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.GET_CARD_RARITY](id: number) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/card_rarities/${id}`)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_RARITY, data["card_rarity"]);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.CREATE_CARD_RARITY](params: Record<string, unknown>) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.post("admin/card_rarities", { card_rarity: params })
        .then(({ data }) => {
          if (data.success) {
            this.context.commit(Mutations.SET_CARD_RARITY, data["card_rarity"]);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.UPDATE_CARD_RARITY](credentials: { id: number; values: Record<string, unknown> }) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.put(`admin/card_rarities/${credentials.id}`, { card_rarity: credentials.values })
        .then(({ data }) => {
          if (data.success) {
            this.context.commit(Mutations.SET_CARD_RARITY, data["card_rarity"]);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.DELETE_CARD_RARITY](id: number) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.delete(`admin/card_rarities/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.GET_ALL_CARD_RARITIES]() {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/card_rarities/all")
        .then(({ data }) => {
          this.context.commit(Mutations.SET_ALL_CARD_RARITIES, data["card_rarities"] || []);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }
}
